module.exports = __webpack_public_path__ + "img/graduated-2-min.d7586054.png";